































































import { EssentialProductFilter, ProductSearchFilter } from '@eurogast/hub-client-typescript';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';
import AutoCompleteHeader from '@/search-form/search-result/AutoCompleteHeader.vue';
import AutoCompleteProducts from '@/search-form/search-result/AutoCompleteProducts.vue';
import AutoCompleteCategoryLinks from '@/search-form/search-result/AutoCompleteCategoryLinks.vue';
import { DependencyService } from '@/services/DependencyService';
import { AutoCompleteResponse } from '@/services/product/completion/ProductCompletionService';
import MatomoSearch from '@/matomo/MatomoSearch';

@Component({
  components: {
    AutoCompleteCategoryLinks,
    AutoCompleteProducts,
    AutoCompleteHeader
  }
})
export default class ProductSearchForm extends Vue {

  get showSuggestions() {
    return this.autocompleteActive &&
        this.suggestions &&
        this.suggestions.products.length > 0;
  }

  get showAllButtonText(): string {
    return this.$t(
        'searchForm.showAllProductsFor',
        { totalAmount: this.suggestions.totalNumberOfElements, query: this.query }
        ).toString();
  }

  @Prop(({default: ''}))
  public localQueryString: string;
  @Prop({default: '/browse'})
  public localBrowseUrl: string;
  @Prop({default: '/search'})
  public localSearchUrl: string;

  private productCompletionService = DependencyService.getProductCompletionService();

  public autocompleteActive = false;
  public query = this.localQueryString;
  public suggestions: AutoCompleteResponse = AutoCompleteResponse.emptyResponse();
  public updateSuggestionList = true;
  public tenant = ConfigService.getTenant();

  public lastUpdatedQuery = '';
  public essentialFilterField: string = 'essential';
  public essentialFilter = EssentialProductFilter.IGNORE;

  public mounted() {
    document.addEventListener('click', () => {
      this.autocompleteActive = false;
    });
  }

  @Watch('query')
  public updateSuggestions() {
    if (this.query === '') {
      this.suggestions.products = [];
      this.suggestions.categories = [];
      return;
    }
    if (this.updateSuggestionList) {
      this.updateSuggestionList = false;
      window.setTimeout(() => {
        this.updateSuggestionList = true;
        if (this.lastUpdatedQuery !== this.query) {
          this.updateSuggestions();
        }
      }, 500);
      this.lastUpdatedQuery = this.query;
      const completionBody = {
        query: this.query,
        filter: this.getFilter()
      };

      this.productCompletionService
          .completeProducts(completionBody)
          .then((res) => {
            this.suggestions = res;
            MatomoSearch.updateSearchEvent(this.query, this.suggestions.products.length);
          }).catch(ApiService.defaultErrorHandler);
    }
  }

  public filterSubmit(ev) {
    if (!this.query) {
      ev.preventDefault();
    }
  }

  public submitForm(searchScope = EssentialProductFilter.IGNORE) {
    this.essentialFilter = searchScope;
    this.$nextTick(() => {
      (this.$refs.searchForm as HTMLFormElement).submit();
    });
  }

  private getFilter(): ProductSearchFilter {
    return {
      essential: this.essentialFilter
    };
  }
}
